import { UI_COLORS, colorHelpers } from '../../utils/colors';
import { useTranslation } from 'react-i18next';

/** Map a status value to a color from the shared STATUS palette. */
const colorForStatus = (s) => {
  const v = (s || '').toLowerCase();
  if (['delivered', 'invoiced', 'completed', 'received', 'confirmed', 'approved', 'converted'].includes(v)) return UI_COLORS.STATUS.SUCCESS;
  if (['cancelled', 'rejected', 'failed'].includes(v)) return UI_COLORS.STATUS.ERROR;
  if (['in_transit', 'delivery_assigned', 'loading', 'loaded', 'in_progress', 'advice_created', 'partial_advice_created'].includes(v)) return UI_COLORS.STATUS.INFO;
  return UI_COLORS.STATUS.WARNING; // pending / default
};

/**
 * Status pill for portal lists. `labels` is the resolved status-label map for
 * the entity (orders/POs/inquiries); falls back to a title-cased value.
 */
const PortalStatusBadge = ({ status, labels }) => {
  useTranslation(); // ensure re-render on language change
  const s = (status || '').toString().toLowerCase();
  const color = colorForStatus(s);
  const label = (labels && labels[s]) || (status ? String(status).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : '—');
  return (
    <span
      className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold"
      style={{ color, backgroundColor: colorHelpers.withOpacity(color, 0.12) }}
    >
      {label}
    </span>
  );
};

export default PortalStatusBadge;
